import _ from "lodash";
import { settingsDefaultValues, settingsOptions } from "utils/constants/settings-constants";
import store from "services/redux/store";
import { dataConstants } from "services/redux/data/constants";

const HelperSetting = {
	
	isReady: () => {
		return !_.isEmpty( _.get(  store.getState().data, dataConstants.SETTINGS, null ) );
	},
	
	get: ( key, fallback = null, settings = null ) => {
		const _settings = settings ?? store.getState().data[ dataConstants.SETTINGS ];
		
		return _.get( _settings, key, fallback !== null ? fallback : _.get( settingsDefaultValues, key, null ) );
	},
	
	/**
	 *
	 * @param key
	 * @returns {boolean}
	 */
	isYes: ( key ) => {
		return HelperSetting.get( key ) === settingsOptions.YES;
	},

	/**
	 *
	 * @param key
	 * @returns {boolean}
	 */
	isNo: ( key ) => {
		return HelperSetting.get( key ) === settingsOptions.NO;
	}
}

export default HelperSetting
